/* focusable.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._2mwq1gjf%3Afocus-visible%7Boutline-offset%3Acalc(0px%20-%20var(--ds-border-width-focused%2C%202px))%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ah31gjf%3Afocus-visible%7Boutline-offset%3Acalc(0px%20-%20var(--ds-border-width-focused%2C%202px))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._1cvmnqa1%3Afocus-visible%7Boutline-style%3Asolid%7D._4davt94y%3Afocus-visible%7Boutline-width%3A1px%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._128mdkaa%3Afocus-visible%7Boutline-width%3Avar(--ds-border-width-focused%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ra3xnqa1%3Afocus-visible%7Boutline-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ah3dkaa%3Afocus-visible%7Boutline-offset%3Avar(--ds-border-width-focused%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._mizu194a%3Afocus-visible%7Boutline-color%3Avar(--ds-border-focused%2C%232684ff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zcxs1o36%3Afocus%3Anot(%3Afocus-visible)%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ypr0glyw%3Afocus%3Anot(%3Afocus-visible)%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ymio1r31%3Afocus%3Anot(%3Afocus-visible)%7Boutline-color%3AcurrentColor%7D");
import { type ComponentPropsWithoutRef, type ComponentPropsWithRef, forwardRef, type ReactElement, type ReactNode } from 'react';
import type { BasePrimitiveProps, StyleProp } from '../components/types';
const focusRingStyles = null;
const insetFocusRingStyles = null;
type AllowedElements = Exclude<keyof JSX.IntrinsicElements, 'button' | 'a'>;
type CustomElement<P = any> = { [K in AllowedElements]: P extends JSX.IntrinsicElements[K] ? K : never }[AllowedElements];
export type FocusableProps<T extends CustomElement> = Omit<ComponentPropsWithoutRef<T>, keyof BaseFocusableProps<T> | 'className' | 'style'> & BasePrimitiveProps & StyleProp & BaseFocusableProps<T>;
type BaseFocusableProps<T extends CustomElement> = {
  /**
   * The DOM element to render as the Focusable element.
   * @default 'button'
   */
  as?: T;
  children?: ReactNode;
  /**
   * Controls whether the focus ring should be applied around or within the composed element.
   */
  isInset?: boolean;
  /**
   * Forwarded ref.
   */
  ref?: ComponentPropsWithRef<T>['ref'];
};
type FocusableComponent = <T extends CustomElement>(props: FocusableProps<T>) => ReactElement;

/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */
const Focusable = (forwardRef(<T extends CustomElement,>({
  as: Component = ('button' as T),
  children,
  isInset,
  testId,
  style,
  xcss,
  ...htmlAttributes
}: FocusableProps<T>, ref: FocusableProps<T>['ref']) => {
  // This is to remove className from safeHtmlAttributes
  // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
  const {
    className: _spreadClass,
    ...safeHtmlAttributes
  } = htmlAttributes;
  return <Component {...safeHtmlAttributes}
  // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
  ref={ref} className={ax(["_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y", isInset && "_1ah31gjf _2mwq1gjf", xcss])}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
  style={style} data-testid={testId}>
				{children}
			</Component>;
}) as FocusableComponent);
export default Focusable;